import { DocumentNode } from '../../types/RealtaDocument';

export const SELECT_DOCUMENT_NODE = 'documentNode/SELECT_DOCUMENT_NODE';

export const selectDocumentNode = (documentNode: DocumentNode) => ({
  type: SELECT_DOCUMENT_NODE,
  payload: documentNode,
});
